// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsCloneResult = objectOf({
  campaign: objectOf({
    campaign_name: string,
    campaign_description: string,
    id: string,
    api_campaign_id: string,
    app_group_id: string,
    segments_data_array: arrayOf(nullOrUndefined),
    filters: arrayOf(
      objectOf({
        filter_key: string,
        display_name: string,
        varies_by_app_group: boolean,
        allowed_for_territories: boolean,
        only_for_workflow_step: boolean,
        allowed_for_predictions: boolean,
        additional_filter_data: objectOf({}),
        value: number,
        comparison_key: string,
      })
    ),
    enabled: boolean,
    currently_sending: boolean,
    last_sent_message: number,
    last_sent: number,
    last_sent_type: nullOrUndefined,
    is_currently_expired: boolean,
    last_archived_campaign_summaries_at: number,
    last_offloaded_retargeting_data_at: number,
    ready_to_offload_retargeting_data: nullOrUndefined,
    last_restored_retargeting_data_at: number,
    future_retargeting_data_offload_at: number,
    currently_deleting_campaign_summaries: nullOrUndefined,
    last_stopped_at: number,
    match_more_than_once: boolean,
    ignore_global_frequency_capping: boolean,
    exclude_from_global_frequency_count: boolean,
    can_match_again_after_seconds: number,
    schedule_type: string,
    schedule_data: objectOf({
      start_date_time: number,
      deliver_in_local_time: boolean,
      optimal_time_notification: boolean,
      use_app_group_best_time: nullOrUndefined,
      optimal_time_default_hour: nullOrUndefined,
      optimal_time_default_minute: nullOrUndefined,
      quiet_start_hour: nullOrUndefined,
      quiet_start_minute: nullOrUndefined,
      quiet_end_hour: nullOrUndefined,
      quiet_end_minute: nullOrUndefined,
      has_quiet_time: boolean,
      content_card_delivery_control: nullOrUndefined,
      display_text: string,
      next_occurrence: number,
      recurring: boolean,
      frequency: string,
      repeat_interval: number,
      weekdays: objectOf({
        monday: boolean,
      }),
    }),
    trigger_schedule_data: nullOrUndefined,
    messaging_actions: arrayOf(
      objectOf({
        api_message_id: string,
        campaign_base_id: string,
        variation_id: string,
        is_active: boolean,
        message_type: string,
        is_control: boolean,
        name: string,
        send_percentage: number,
        optimal_send_percentage: nullOrUndefined,
        link_template_ids: nullOrUndefined,
        link_config_set: objectOf({}),
        last_sent_webhook: number,
        webhook_url: string,
        webhook_method: string,
        webhook_headers: objectOf({
          "Content-type": string,
        }),
        webhook_body_type: string,
        webhook_body: string,
      })
    ),
    max_recipients: number,
    max_recipients_is_global: boolean,
    time_rate_limit: nullOrUndefined,
    recipient_subscription_state: number,
    created: objectOf({
      time: number,
      name: string,
      d_id: string,
    }),
    last_edit: objectOf({
      time: number,
      name: string,
      d_id: string,
    }),
    is_archived: boolean,
    last_draft_step: number,
    is_draft: boolean,
    draft_is_set_to_send_immediately: boolean,
    campaign_type: string,
    composition_mode: string,
    user_type: string,
    conversion_behaviors: arrayOf(
      objectOf({
        event_type: string,
        performed_behavior_window_in_seconds: number,
        app_ids: nullOrUndefined,
        type: string,
      })
    ),
    automatic_distribution_optimization: boolean,
    send_percentage_optimization_complete: boolean,
    ip_pool: nullOrUndefined,
    uses_old_conversion_stat: boolean,
    total_sent: number,
    tag_names: arrayOf(nullOrUndefined),
    conversion_filter_descriptions: arrayOf(string),
    priority_bucket: nullOrUndefined,
    priority: nullOrUndefined,
    associated_card_id: nullOrUndefined,
    territory_ids: arrayOf(nullOrUndefined),
    has_completed_wizard: boolean,
    completed_wizard_steps: nullOrUndefined,
    invalid_wizard_steps: nullOrUndefined,
    seed_exclude_already_sent_not_updated: boolean,
    campaign_alerting: nullOrUndefined,
    audience_stats_initially_estimated: boolean,
    is_transactional: nullOrUndefined,
    can_be_copied_across_app_groups: boolean,
    audience_description_hash: objectOf({
      filters: arrayOf(arrayOf(string)),
      segments: arrayOf(nullOrUndefined),
      apps: arrayOf(nullOrUndefined),
    }),
    rate_limit_alert_data: objectOf({
      rate_limit_alert: nullOrUndefined,
      aborted_due_to_rate_limit: nullOrUndefined,
    }),
    step_approvals: objectOf({}),
    content_card_delivery_control: nullOrUndefined,
    supports_stats_by_send_time: nullOrUndefined,
    is_idle: boolean,
    stop_date: nullOrUndefined,
    push_max_enabled: boolean,
    is_restoration_pending: boolean,
    has_post_launch_draft: boolean,
    attached_images: arrayOf(nullOrUndefined),
    targets_android: boolean,
    first_sent: number,
  }),
});
